import React from 'react';
import PropTypes from 'prop-types';

import {mergeRefs} from '../../../../lib/refHelper';
import {droppable} from '../../../../lib/dragAndDrop';

const CardDropZone = React.forwardRef(({drop, isOver, canDrop, isLast}, ref) => (
  <div
    ref={mergeRefs(drop, ref)}
    style={{
      width: '100%',
      height: 'fit-content',
      flexGrow: isLast ? 1 : 0,
    }}
  >
    <div style={{height: 7, background: canDrop && isOver ? '#414402' : 'none'}} />
  </div>
));

CardDropZone.propTypes = {
  drop: PropTypes.any.isRequired,
  isOver: PropTypes.bool,
  canDrop: PropTypes.bool,
  isLast: PropTypes.bool,
};

CardDropZone.defaultProps = {
  isOver: false,
  canDrop: false,
  isLast: false,
};

export default droppable(CardDropZone);
